import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_blue_header/estimate-sent')({
  beforeLoad: () => {
    throw redirect({ replace: true, to: '/devis-envoye' })
  },
})
